<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import { isNull } from 'lodash'
  import MultiSelectInput from '@/components/ui/MultiSelectInput'
  import ImageUploader from '@/components/ui/ImageUploader'

  export default {
    name: 'CreateGroupOverlay',
    components: {
      MultiSelectInput,
      ImageUploader,
      ImageCropper: () => import('@/components/modules/ImageCropper'),
    },
    props: {
      isOpen: Boolean,
    },
    data() {
      return {
        overlayImageCropper: false,
        overlayUpload: false,
        selectedUsers: [],
        name: '',
        description: '',
        uploadedImage: {
          id: null,
          url: null,
        },
        imageUploaderConfig: {
          // Should add file config properties here which different from FileUploader's baseConfig settings
        },
      }
    },
    computed: {
      ...mapState('users', ['users']),
      ...mapState('auth', ['settings']),
      ...mapState('groups', ['pending']),
      opened: {
        set() {
          this.$emit('onCloseOverlay')
        },
        get() {
          return this.isOpen
        },
      },
      disableButton() {
        return this.settings.stream_options && this.settings.stream_options.group_image_required && isNull(this.uploadedImage.url)
      },
    },
    created() {
      this.getSearchedUsers()
    },
    methods: {
      ...mapActions('groups', ['uploadImage']),
      ...mapActions('users', ['getSearchedUsers']),
      onSearch(arg) {
        this.getSearchedUsers(arg)
      },
      onSubmit() {
        this.$emit('submit', {
          name: this.name,
          description: this.description,
          users: this.selectedUsers,
          img_id: this.uploadedImage.id,
          type: 'groups',
        })
      },
      onResultsUpdate(args) {
        this.selectedUsers = args
      },
      openImageCropper(image) {
        this.uploadedImage = image
        // to fix preview
        this.uploadedImage.url += '?cropped'

        this.overlayUpload = false
        this.overlayImageCropper = true
      },
      removeFile() {
        this.uploadedImage = {
          url: null,
          id: null,
        }
      },
      onCropperSave(coordinates) {
        this.uploadImage({ coordinates, id: this.uploadedImage.id }).then(data => {
          this.overlayImageCropper = false
          this.uploadedImage = data
        })
      },
    },
  }
</script>
